import "@hotwired/turbo-rails"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/modal"
import "../../controllers"
import "./lightgallery"
import "./navbar_overlay"
import "./slick_carousels"
